// developed by Param Partap Singh
import React from "react";
import Nav from "../Utils/Nav";
import service from "../Assets/service-image.JPG";
import banner from "../Assets/background2.JPG";
import "../Css/Home.css";
import Footer from "../Utils/Footer";

export default function Home() {
  return (
    <>
      <Nav />
      <div className="main-container">
        <div className="banner">
            <img className="background" src={banner} alt="" />
        <h1 className="main-heading-title">Services and support</h1>

        </div>
        <div className="container">
          <div className="left">
            <h3 style={{ marginBottom: "10px" }} className="heading">
              We provide the following IT related services to IIT Ropar users:
            </h3>
            <div className="list-items">
              <ul>
                <li>Email accounts on iitrpr.ac.in domain.</li>
                <li>
                  LDAP account for allowing access to IIT Ropar applications and
                  services.
                </li>
                <li>VPN access to IIT Ropar networks.</li>
                <li>
                  Management of the following central IT services: networks
                  (LAN/WiFi), servers in our data centers, IP phones, IP based
                  surveillance.
                </li>
                <li>
                  Technical support for AV systems in lecture halls and
                  meeting/seminar rooms.
                </li>
                <li>Management of IIT Ropar website.</li>
                <li>
                  Technical support for the software that we have developed.
                </li>
              </ul>
            </div>

            <h3
              style={{ marginTop: "30px", marginBottom: "10px" }}
              className="heading"
            >
              We DO NOT handle the following:
            </h3>
            <div className="list-items">
              <ul>
                <li>Operating the AV systems in meetings/lectures/events.</li>
                <li>Data entry into any applications.</li>
                <li>Repair of IT hardware.</li>
                <li>
                  Software development (including websites) for
                  departments/individuals/groups.
                </li>
                <li>
                  Submit a support ticket <a href="https://www.iitrpr.ac.in/itsupport/" target="_blank" style={{color:"red", textDecoration:"none"}}>Click Here</a>. View
                  replies to common support requests <a href="https://www.iitrpr.ac.in/itsupport/ticket.php" target="_blank" style={{color:"red", textDecoration:"none"}}>Click Here</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="right">
            <img src={service} alt="" />
          </div>
        </div>


        <div className="lower-container">
        <h1 className="main-heading" style={{marginTop:"100px"}}>Overall Expected Turnaround Time</h1>
        
        <div className="box-containt">
            {/* <div className="box">
                <h2>Installaton of OS:</h2>
                <ul>
                    <li>Windows + Office: 1 hour for installation after the creation of bootable disk</li>
                    <li>Linux: Approx. 30 minutes after the creation of the bootable media</li>
                </ul>
            </div> */}
            {/* <div className="box">
                <h2>Printer Repair:</h2>
                <ul>
                    <li>Driver Installation: Approx. 30-60 minutes</li>
                    <li>Cartridge Change: 10-15 minutes</li>
                    <li>Other Faults: depends on the nature of the faults</li>
                </ul>
            </div> */}
            <div className="box">
                <h2>Network:</h2>
                <ul>
                    <li>LAN Port: Usually if it is from the user end (like IP Address not getting
                        assigned) then upto 10 minutes, if it is from the switch end then depends on the nature of the fault</li>
                    <li>WiFi: Entirely depends on the nature of the call</li>
                    <li>Sites not working: Usually, 15-20 minutes if it is from our end otherwise depends on ISP (if the
                        site is blocked from ISP end)</li>
                    <li>Installation of new switches: 5-6 hours including configuration.</li>
                    
                </ul>
            </div>
            <div className="box">
                <h2>Servers:</h2>
                <ul>
                    <li>Installation of server and OS: 3-4 hours after call assignments
                    </li>
                    <li>Creation of containers: 1-2 hours after call assignments
                    </li>
                </ul>
            </div>
            <div className="box">
                <h2>Email-id’s and Group-id’s:</h2>
                <ul>
                    <li>1 hours after call assignments
                    </li>
                </ul>
            </div>
            <div className="box">
                <h2>Creation of Webforms:</h2>
                <ul>
                    <li>1.5 to 2 hours after setting up all the modules.
                    </li>
                </ul>
            </div>
            <div className="box">
                <h2>Webpage Creation/Updation:</h2>
                <ul>
                    <li>Depends upon the content/Design requested.(Approx. Time 3-4).
                    </li>
                </ul>
            </div>
            <div className="box">
                <h2>Moodle:</h2>
                <ul>
                    <li>
                    Quiz/Course Creation, updation,replication : 1-2 hours after call assignments.
                  </li>
                </ul>
            </div>
            
        </div>
        
        
        </div>

      </div>

       <Footer/>
    </>
  );
}
